import { immerable } from 'immer';

/**
 * This class needs to be extended by all classes saved in redux store
 * It makes it possible to mutate class properties in the slice reducers
 */
export class Immerable {
  readonly [immerable] = true;
}